<template>
    <!--弹窗-->
    <el-dialog width="500px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="formData" :model="formData" label-width="100px" size="mini">

            <template>
                <el-form-item label="负责人" v-show="modalType === 1">
                    <el-select v-model="formData.operator_id" placeholder="请选择" size="mini">
                        <el-option :label="item.full_name" :value="item.id"
                                   v-for="item in managerAnalysisList"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="广告控制人" v-show="modalType === 2">
                    <el-select v-model="formData.controller_id" placeholder="请选择" size="mini">
                        <el-option :label="item.full_name" :value="item.id"
                                   v-for="item in managerAnalysisList"></el-option>
                    </el-select>
                </el-form-item>
            </template>

        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose"
            >取 消
            </el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm()" :loading="loading">确定
            </el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from '@/api/Product/Product.js'

export default {
    data() {
        return {
            visible: false,
            loading: false,
            managerAnalysisList: [],
            title: '',
            formData: {},
            modalType: 1,
        }
    },
    methods: {
        openModal(data, list, type) {
            const tempData = JSON.parse(JSON.stringify(data))
            this.formData = tempData
            this.managerAnalysisList = list
            this.modalType = type
            this.title = type === 1 ? '修改负责人' : '修改广告控制人'
            this.visible = true
        },
        submitForm() {
            this.loading = true
            let params = {
                id: this.formData.id
            }
            if (this.modalType == 1) {
                params.operator_id = this.formData.operator_id
            } else {
                params.controller_id = this.formData.controller_id
            }
            api.seed_word_asin_list_update_field(params).then(res => {
                if (res.code === 0) {
                    this.$message({message: '修改成功', type: 'success'})
                    this.handleClose(false)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.loading = false
            this.visible = false
            this.$emit('close-callback', isshow)
        }
    }
}
</script>
